module.exports = __webpack_public_path__ + "img/phone-office.af174df5.png";